// Invitations (SM-722): the caller's pending memberships on other nodes.
// A user-level screen — it needs no capability on the selected node,
// because accepting or declining acts on the caller's own membership.
//
//   POST /api/broker/me/memberships/{id}/activate
//   POST /api/broker/me/memberships/{id}/leave   {reason}
import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/layout/PageHeader";
import { useScope } from "@/components/layout/ScopeContext";
import { InvitationList } from "@/components/layout/Invitations";
import { SectionCard } from "@/components/ui/Card";
import { invitedMemberships } from "@/lib/capabilities";
import { useI18n } from "@/i18n/I18nProvider";

export const Route = createFileRoute("/_app/invitations")({
  component: InvitationsPage,
});

function InvitationsPage() {
  const { t } = useI18n();
  const { staff } = useScope();
  return (
    <>
      <PageHeader title={t("invitations.title")} subtitle={t("invitations.subtitle")} coverage="none" />
      <SectionCard title={t("invitations.pending")}>
        <InvitationList invitations={invitedMemberships(staff)} />
      </SectionCard>
    </>
  );
}
